/**
 * Thin boundary that isolates `import.meta.env` reads so the rest of the
 * auth code (and its tests) can stay environment-agnostic. Jest tests mock
 * this module; application code imports from `./auth.js` as usual.
 */

export function readOktaEnv(key) {
  return (import.meta.env && import.meta.env[key]) || '';
}

export function readBaseUrl() {
  return (import.meta.env && import.meta.env.BASE_URL) || '/';
}

export function readOrigin() {
  return typeof window !== 'undefined' && window.location
    ? window.location.origin
    : '';
}
